import { render, staticRenderFns } from "./ListOffer.vue?vue&type=template&id=6dff27ba&scoped=true"
import script from "./ListOffer.vue?vue&type=script&setup=true&lang=ts"
export * from "./ListOffer.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ListOffer.vue?vue&type=style&index=0&id=6dff27ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dff27ba",
  null
  
)

export default component.exports